"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOST_VIEWED = exports.PRICE_DESC = exports.PRICE_ASC = exports.DATE_DESC = void 0;
exports.DATE_DESC = 'date_desc';
exports.PRICE_ASC = 'price_asc';
exports.PRICE_DESC = 'price_desc';
exports.MOST_VIEWED = 'most_viewed';
var ResultsListConfig = {
    SKELETON_COUNT: 4,
    SORT_BY: {
        DEFAULT: exports.DATE_DESC,
        OPTIONS: [exports.PRICE_ASC, exports.PRICE_DESC, exports.DATE_DESC],
        TRANSLATION_NAMESPACE: 'SORT',
    },
};
exports.default = ResultsListConfig;
